export default __webpack_public_path__ + "static/media/payment-methods@3x.7afe9641.jpg";